import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import jwt from 'jwt-decode';
// @ts-ignore
import Drawer from 'components/Nav/Drawer';
import Footer from 'components/Nav/Footer';
import Navbar from 'components/Nav/Navbar';
import Tableau from 'components/Tableau';

export const ContentContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box sx={{ py: { xs: 2, sm: 2, md: 0, lg: 0 }, px: { xs: 1, sm: 1, md: 4, lg: 8 } }}>
      <Box py={2}>
        <Navbar />
      </Box>
      {children}
    </Box>
  );
};

export const TuDashboard = ({ userName }: { userName: string }) => {
  return (
    <Box mb={2} style={{ marginTop: '-15px' }}>
      <Typography
        sx={{ fontSize: { xs: '1.8rem', sm: '3rem' } }}
        variant="h3"
        fontWeight="700"
      >
        &lt;<Typography component="span" color="primary.main" sx={{ fontSize: { xs: '2rem', sm: '3.3rem' } }} variant="h3" fontWeight="700">¡Bienvenido!</Typography>&gt;
      </Typography>
    </Box>
  );
};

const DashboardIndex = () => {
  const { clientCompany: userName } = jwt(localStorage.getItem('token') as string) as any;
  const tableauToken = localStorage.getItem('tableauToken') as string;

  return (
    <ContentContainer>
      <Drawer>
        <TuDashboard userName={userName} />

        <Box mb={2} style={{ marginTop: '15px' }}>
          <Typography component="span" color="primary.main" sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }} variant="h3">
            ¿Que es el portal tapi?
          </Typography>

          <p>
            El portal tapi es el lugar en donde vas a poder monitorear y controlar la funcionalidad de bill payments de tu aplicación.
            Dentro de este portal, vas a encontrar las métricas más importantes a visualizar para velar por una buena experiencia y también poder encontrar puntos de mejora.
            <br />En este mismo lugar, también vas a poder ingresar a nuestro portal de soporte Jira, y próximamente a muchas mas funcionalidades (archivos de rendición, reportes semanales, etc.)
            <br />Esta información estará disponible near real-time, pasando por un proceso de ELT validado y llevado adelante por nuestro equipo de Data. Será su principal herramienta una vez en producción para poder ir evaluando el funcionamiento de la integración.
          </p>
        </Box>


        <Box mb={2} style={{ marginTop: '15px' }}>

          <Typography component="span" color="primary.main" sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }} variant="h3">
            ¿Que puedo ver en el portal tapi?
          </Typography>

          <p>
            En nuestro portal vas a encontrar los distintos Dashboards con toda tu información de uso e interacción con nuestras APIs. Nuestros Dashboards interactivos te permiten visualizar toda esta información de distintas maneras. Filtrando por Fecha, País (en caso de encontrarse en mas de uno), Biller y mucho mas…
          </p>

        </Box>

        <Box mb={2} style={{ marginTop: '15px' }}>
          <Typography component="span" color="primary.main" sx={{ fontSize: { xs: '1rem', sm: '1rem' } }}>
            Información transaccional
            <Typography component="span" sx={{ fontSize: { xs: '1rem', sm: '1rem' } }}>
              → en esta sección se encuentran los números mas importantes a nivel general de toda la funcionalidad de Bill Payments
            </Typography>
          </Typography>
        </Box>

        <Box mb={2} style={{ marginTop: '15px' }}>
          <ul className='css-3v6xgr-MuiTypography-root'>
            <li>Cantidad total de transacciones</li>
            <li>Monto transaccionado</li>
            <li>Ticket promedio</li>
            <li>Share monto transaccionado por país/vertical</li>
            <li>Métodos de pago utilizados</li>
          </ul>

        </Box>


        <Box mb={2} style={{ marginTop: '15px' }}>
          <Typography component="span" color="primary.main" sx={{ fontSize: { xs: '1rem', sm: '1rem' } }}>
            Performance del flujo
            <Typography component="span" sx={{ fontSize: { xs: '1rem', sm: '1rem' } }}>
              → aquí podemos ver como esta interactuando el usuario con los distintos momentos del flujo
            </Typography>
          </Typography>
        </Box>

        <Box mb={2} style={{ marginTop: '15px' }}>
          <ul className='css-3v6xgr-MuiTypography-root'>
            <li>Cantidad de deudas consultadas</li>
            <li>Ratio pagos exitosos sobre pagos procesados</li>
            <li>Funnel consulta de deuda → pago confirmado</li>
          </ul>

        </Box>



        <Box mb={2} style={{ marginTop: '15px' }}>
          <Typography component="span" color="primary.main" sx={{ fontSize: { xs: '1rem', sm: '1rem' } }}>
            Comportamiento de usuarios
            <Typography component="span" sx={{ fontSize: { xs: '1rem', sm: '1rem' } }}>
              → enfocado en números a nivel Usuarios usando esta funcionalidad
            </Typography>
          </Typography>
        </Box>

        <Box mb={2} style={{ marginTop: '15px' }}>
          <li>Cantidad de usuarios pagadores</li>
          <li>Nuevos usuarios pagadores los últimos x días</li>
          <li>Promedio pagos/targets por usuario</li>
          <li>Top empresas pagadas</li>
          <li>Cohorts retención de usuarios</li>

        </Box>
      </Drawer>
      <Footer />
    </ContentContainer >
  );
};

export default DashboardIndex;
